import http from "./httpService";
import { apiUrl } from "../config";

export function getLinkedAccountList() {
  return http.get(`${apiUrl}ClientMasterAccount/GetLinkedAccountList`);
}

export function checkCredentials(credentials) {
  return http.post(
    `${apiUrl}ClientMasterAccount/CheckCredentials`,
    credentials
  );
}

//endpoint to switch to a linked account
export function changeUserToken(clientId, masterName) {
  return http.post(`${apiUrl}ClientMasterAccount/ChangeUserToken`, {
    ClientId: clientId,
    MasterName: masterName,
  });
}

export function switchBackToMasterAccount() {
  return http.get(`${apiUrl}ClientMasterAccount/SwitchBackToMasterAccount`);
}
